export default __webpack_public_path__ + "static/media/Flag_of_the_United_Kingdom.svg.52c273ce.webp";